import React, { createContext, useState } from 'react';

// Create the context
const CommonDataContext = createContext();

// Provider component
const CommonDataProvider = ({ children }) => {
  // Define the shared state here
  const [editLead, setEditLead] = useState();

  // Create a value object that holds the shared data and any functions you want to expose
  const value = {
    editLead,
    setEditLead,
  };

  return (
    <CommonDataContext.Provider value={value}>
      {children}
    </CommonDataContext.Provider>
  );
};

export { CommonDataProvider, CommonDataContext };